import { render, staticRenderFns } from "./navdepenseLocal.vue?vue&type=template&id=ece87b12&"
import script from "./navdepenseLocal.vue?vue&type=script&lang=js&"
export * from "./navdepenseLocal.vue?vue&type=script&lang=js&"
import style0 from "./navdepenseLocal.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports